<template>
  <div class="py-2">
    <div class="flex justify-between items-center gap-4" :data-cy="dataCy">
      <AtomText :text="label" font-size="text-sm" class="shrink-0" />

      <div class="flex gap-2 items-center">
        <div class="flex flex-col items-end text-right">
          <slot />
        </div>

        <MoleculeButton
          :data-cy="dataCy ? `${dataCy}-edit` : undefined"
          :aria-label="`${t('subscription.informationsSummary.edit')} ${label}`"
          @click="emit('edit', editStep)"
          variant="minimal"
          icon-name="PencilIcon"
          icon-type="solid"
          size="xs"
          v-if="editStep"
        />
      </div>
    </div>

    <div class="flex mb-2" v-if="description">
      <AtomText :text="description" color-variant="description" font-size="text-sm" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import type { SubscriptionRouteName } from '@/types/router.type';

defineProps<{
  label: string;
  description?: string;
  editStep?: SubscriptionRouteName;
  dataCy?: string;
}>();

const emit = defineEmits<{ edit: [step: SubscriptionRouteName] }>();

const { t } = useI18n();
</script>
